export default __webpack_public_path__ + "static/media/SEC2060.34I-43068_-25737_0.cc6e4cc8.jpg";